module.exports = __webpack_public_path__ + "static/clouds-min-49eabc8eb0449b4cab36461fb8fe578b.png";